import React from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";

import bg from "../../assets/images/bg.jpg";
import image from "../../assets/images/logo192.png";
import {
  HiOutlineCog,
  HiOutlineKey,
  HiOutlineUser,
  HiOutlineUserGroup,
} from "react-icons/hi2";

const navItems = [
  {
    label: "Connected Accounts",
    path: "accounts",
    icon: HiOutlineKey,
  },
  {
    label: "Banks",
    path: "banks",
    icon: HiOutlineUser,
  },
  {
    label: "Family",
    path: "family",
    icon: HiOutlineUserGroup,
  },
  {
    label: "Preferences",
    path: "/profile/preferences",
    icon: HiOutlineCog,
  },
];

export const ProfileContainer: React.FC = () => {
  const location = useLocation();
  const { providerUser } = useUser();

  return (
    <div className="relative min-h-screen pt-24 bg-amber-600/5">
      {/* Profile Banner */}
      <div className="relative shrink-0">
        <img
          src={bg}
          className="h-80 w-full object-cover"
          id="profile-banner"
          alt="Profile Banner"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/70" />
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 -mt-32 relative z-10">
        <div className="grid grid-cols-12 gap-6">
          {/* Profile Sidebar */}
          <div className="col-span-12 lg:col-span-4 xl:col-span-3">
            <div className="p-6 rounded-xl shadow-lg dark:shadow-gray-800 bg-white dark:bg-slate-900 backdrop-blur-lg">
              {/* Profile Picture */}
              <div className="profile-pic text-center mb-5">
                <div className="relative size-28 mx-auto">
                  <img
                    src={providerUser?.photoURL || image}
                    className="rounded-full shadow-lg dark:shadow-gray-800 ring-4 ring-indigo-600/20 dark:ring-indigo-400/20"
                    id="profile-image"
                    alt="Profile"
                  />
                  <div className="absolute -bottom-2 -right-2 size-8 bg-green-500 rounded-full border-4 border-white dark:border-slate-900" />
                </div>
              </div>

              {/* Profile Info */}
              <div className="text-center">
                <h5 className="text-xl font-semibold mb-1">
                  {providerUser?.displayName || "User Name"}
                </h5>
                <p className="text-gray-500 dark:text-gray-400 text-sm">
                  {providerUser?.email || "email@example.com"}
                </p>
              </div>

              {/* Navigation */}
              <nav className="mt-8">
                <ul className="space-y-1">
                  {navItems.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`flex items-center px-4 py-3 rounded-lg transition-all ${
                          location.pathname === `/profile/${item.path}`
                            ? "bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400"
                            : "text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800/50"
                        }`}
                      >
                        <item.icon className="w-5 h-5 mr-3" />
                        <span className="font-medium">{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>

          {/* Content Area */}
          <div className="col-span-12 lg:col-span-8 xl:col-span-9">
            <div className="bg-white dark:bg-slate-900 rounded-xl shadow-lg p-6">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileContainer;
